import React, { useCallback } from 'react';
import { xcss, Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import Button from '@atlaskit/button/new';
import { srcLight as noResultsIllustrationOld } from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/empty/components/search-no-results-old/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useRouterActions } from '@atlassian/react-resource-router';
import { useFiltersPreference } from '@atlassian/jira-business-filters/src/controllers/index.tsx';
import { useSorting } from '@atlassian/jira-business-filters/src/services/sorting/index.tsx';
import { SIMPLE_SEARCH_PARAM, SORT_BY_PARAM, DIRECTION_PARAM } from './constants.tsx';
import messages from './messages.tsx';

type Props = {
	reason?: 'INVALID_JQL' | 'NO_RESULTS';
	clearError?: () => void;
};

export const ErrorState = ({ reason, clearError }: Props) => {
	// @ts-expect-error - TS2339 - Property 'updateQueryParam' does not exist on type 'BoundActions<EntireRouterState, PublicRouterActions>'.
	const { updateQueryParam } = useRouterActions();
	const { formatMessage } = useIntl();
	const { saveJql } = useFiltersPreference();
	const [, setSorting] = useSorting();
	const handleOnClear = useCallback(() => {
		updateQueryParam(
			{
				[SIMPLE_SEARCH_PARAM]: undefined,
				[SORT_BY_PARAM]: undefined,
				[DIRECTION_PARAM]: undefined,
			},
			'replace',
		);
		saveJql(undefined);
		setSorting(undefined);
		clearError?.();
	}, [saveJql, updateQueryParam, setSorting, clearError]);

	const message =
		reason === 'INVALID_JQL'
			? formatMessage(messages.invalidStateHeading)
			: formatMessage(messages.emptyStateHeading);

	return (
		<Box xcss={wrapperStyles}>
			<Box xcss={illustrationStyles}>
				<Image src={noResultsIllustrationOld} alt="" />
			</Box>
			<Box xcss={headerWrapperStyles}>
				<Heading size="medium">{message}</Heading>
			</Box>
			<Button appearance="primary" onClick={handleOnClear}>
				{formatMessage(messages.clearFiltersButton)}
			</Button>
		</Box>
	);
};

const wrapperStyles = xcss({
	textAlign: 'center',
	margin: 'auto',
	width: '450px',
	padding: 'space.300',
	borderRadius: 'border.radius.200',
	background: token('color.background.neutral.subtle'),
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
});

const headerWrapperStyles = xcss({
	marginTop: 'space.400',
	marginBottom: 'space.300',
});

const illustrationStyles = xcss({
	width: '208px',
	height: '190px',
	display: 'flex',
	justifyContent: 'center',
});
